import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Input } from 'reactstrap'

const AmountInput = (props) => {
  const intl = useIntl()
  const {
    name,
    id,
    max,
    cb,
    placeholder,
    dotOnly,
    value,
    idx,
    maxFractionDigits = 0,
    preserveRaw = false,
    testId = 'amount-input',
    ...restProps
  } = props
  const [amount, setAmount] = useState(value || '')

  const formatAmount = (val) => {
    const stringValue = typeof val === 'number' ? String(val) : (val ?? '')

    if (preserveRaw && typeof val === 'string') {
      return stringValue
    }

    let numericValue =
      stringValue.includes(',') && !dotOnly
        ? stringValue
        : Number(
            stringValue
              ?.replace(/[^\d,]/g, '')
              ?.replace(/\./g, '')
              ?.replace(/\,/g, '.'),
          )

    if (max && !isNaN(numericValue) && numericValue > max) {
      numericValue = max
    }

    if (typeof numericValue === 'number' && !isNaN(numericValue)) {
      return intl.formatNumber(numericValue, {
        useGrouping: 'always',
        minimumFractionDigits: 0,
        maximumFractionDigits: maxFractionDigits,
      })
    } else {
      return stringValue
    }
  }

  useEffect(() => {
    setAmount(formatAmount(value))
    if (typeof cb === 'function') {
      cb(formatAmount(value), name, idx)
    }
  }, [value])

  const handleChange = (e) => {
    const inputVal = typeof e === 'object' ? e.target.value : e
    const formatted = formatAmount(inputVal)
    setAmount(formatted)

    if (typeof cb === 'function') {
      cb(formatted, name, idx)
    }
  }

  return (
    <Input
      name={name}
      id={id}
      onInput={handleChange}
      onChange={handleChange}
      onBlur={handleChange}
      value={amount}
      type="text"
      placeholder={placeholder}
      data-testid={testId}
      {...restProps}
    />
  )
}

export default AmountInput
